import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import formatBRL from '../../../shared/utils/formatBRL';

// Gráfico de vendas por período — os buckets já vêm completos do backend
// (dateBuckets), então não precisa de nenhuma lógica extra aqui pra lidar
// com "sem venda": o próprio dado já traz value:0 pros dias/meses/anos sem
// venda nenhuma.
const SalesByPeriodChart = ({ data }) => {
  const points = data || [];

  return (
    <div style={{ width: '100%', height: 260 }}>
      {points.length === 0 ? (
        <p className="text-muted mb-0">Sem dados nesse período.</p>
      ) : (
        <ResponsiveContainer>
          <AreaChart data={points} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="salesByPeriodFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#7c3aed" stopOpacity={0.35} />
                <stop offset="95%" stopColor="#7c3aed" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} interval="preserveStartEnd" />
            <YAxis tick={{ fontSize: 12 }} width={70} tickFormatter={(v) => formatBRL(v)} />
            <Tooltip formatter={(value) => [formatBRL(value), 'Vendas']} />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#7c3aed"
              strokeWidth={2}
              fill="url(#salesByPeriodFill)"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SalesByPeriodChart;
